import React, {useEffect, useState} from "react";
import {Bundle, loadBundles} from "./BundlesApi";
import PackageCard, {PackageCardProps} from "./PackageCard";
import {Grid, Typography} from "@mui/material";
import I18n from "i18n-js";

export enum BundleType {
  MONTHLY = "MONTHLY",
  ANNUAL = "ANNUAL",
  ONE_TIME = "ONE_TIME",
}

export interface BundlesListProps {
  type: BundleType;
}


export default function BundlesList({type}: BundlesListProps) {
  const [bundles, setBundles] = useState<Bundle[]>([]);

  async function updateBundles() {
    const {success, data, error} = await loadBundles(type);

    setBundles(data.data || []);
  }

  useEffect(() => {
    updateBundles();
  }, []);

  return (
    <>
      {bundles.length > 0
        ? bundles.map((bundle: Bundle) => {
          return (
            <Grid item lg={3} md={6} sm={6} xs={12} key={bundle.id}>
              <PackageCard
                {...bundle}
              />
            </Grid>
          );
        })
        :
        <Typography
          variant="body1"
          color="grey"
          align="center"
          sx={{
            width: "100%"
          }}
        >
          {I18n.t("MyAccount.pages.billingAndPlans.bundle.noAvailableBundle")}
        </Typography>
      }
    </>
  );
}